import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import SEO from "@/components/SEO";

const About = lazy(() => import("@/components/About"));
const Courses = lazy(() => import("@/components/Courses"));
const Contact = lazy(() => import("@/components/Contact"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => {
  return (
    <div className="min-h-screen" dir="rtl">
      <SEO
        title="מהדי - מכללה ובית ספר לנהיגה"
        description="הכשרה מקצועית ברמה הגבוהה ביותר עם מורים מנוסים ומסורים. קורסים מגוונים לכל סוגי הרישיונות."
        path="/"
      />
      <Navbar />
      <Hero />
      <Suspense fallback={null}>
        <About />
        <Courses />
        <Contact />
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;